import React from 'react';
import Page from 'src/components/Page';
import { Header } from 'src/components/Headers';
import { Container, Divider, makeStyles, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { ServiceClient } from 'src/constants/modules/serviceClient';
import { SERVICE_CLIENT_AUTH } from 'src/constants/permissions';
import { useServiceClient } from 'src/hooks';
import useAuth from 'src/hooks/useAuth';
import { ServiceClientForm, mapServiceClientToFormValues } from 'src/components/ServiceClients/Form';
import type { TServiceClientFormValues } from 'src/components/ServiceClients/Form';
import { useParams } from 'react-router-dom';
import { CapitalizeNames } from 'src/utils/capitalize';

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100%',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(1),
    },
}));

export const ServiceClientEditView = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { serviceClientId } = useParams<{ serviceClientId: string }>();
    const { user } = useAuth();
    const { updateServiceClient, client } = useServiceClient();

    const handleSubmit = async (values: TServiceClientFormValues) => {
        if (!user?._id) return;
        const payload = {
            name: values.name,
            email: values.email,
            phone: values.phone,
            countryCode: values.countryCode,
            source: values.source,
            store: values.store,
        };
        await updateServiceClient(serviceClientId, payload, { playSound: false });
    };

    return (
        <Page className={classes.root} title={t('serviceClients.Edit')}>
            <Container maxWidth="lg">
                <Header
                    module={ServiceClient.name}
                    route={`${ServiceClient.route}/${serviceClientId}`}
                    crud={{ goBack: true }}
                    permission={SERVICE_CLIENT_AUTH}
                    title={CapitalizeNames(client?.name)}
                />
                <Divider />
                <Box mt={3}>
                    <ServiceClientForm mode="edit" onSubmit={handleSubmit} initialValues={mapServiceClientToFormValues(client)} />
                </Box>
            </Container>
        </Page>
    );
};
